import React from 'react'
import Detail from 'src/modules/EContent/Detail'
import { ECONTENT_TYPE } from 'src/modules/EContent/model'

const EContentArticlePage = () => {
  return <Detail type={ECONTENT_TYPE.E_CONTENT} />
}

export default EContentArticlePage
